<div
    class="tw-flex tw-relative tw-flex-col lg:tw-flex-row md:tw-pb-8 tw-px-6 md:tw-pl-20 md:tw-pr-0 tw-overflow-hidden tw-items-start"
>
    <div
        class="tw-w-full lg:tw-w-3/5 tw-py-6 md:tw-py-16 md:tw-pr-10 lg:tw-pr-20"
    >
        <h2
            class="!tw-w-full !tw-text-[24px] md:!tw-text-[30px] tw-text-[#0F3172] !tw-font-bold !tw-mt-2 !tw-leading-10"
        >
            {{ "ABOUT_US-FAQ.TITLE" | translate }}
        </h2>
        <p
            class="tw-text-[#1A202C] !tw-my-6 !tw-text-[14px] lg:tw-text-[18px] tw-font-medium"
        >
            {{ "ABOUT_US-FAQ.DESC" | translate }}
        </p>
        <div class="tw-flex tw-flex-col tw-gap-4 tw-mt-10 tw-font-normal">
            <div
                *ngFor="let faq of faqs; let i = index"
                [ngClass]="{ 'tw-rounded-lg': openIndex !== i }"
            >
                <button
                    type="button"
                    class="tw-w-full tw-flex tw-justify-between tw-items-center tw-bg-[#EDF1FF] tw-px-6 tw-py-6 tw-text-left tw-font-medium tw-text-[16px] lg:tw-text-[18px] focus:tw-outline-none tw-transition-colors tw-duration-200"
                    [ngClass]="{
                        'tw-rounded-t-lg': openIndex === i,
                        'tw-rounded-lg': openIndex !== i
                    }"
                    (click)="toggleAccordion(i)"
                >
                    <span>{{
                        currentLang === "en" ? faq.questionEN : faq.questionBM
                    }}</span>
                    <span
                        class="tw-flex tw-items-center tw-justify-center tw-min-w-[2rem] tw-min-h-[2rem] tw-w-8 tw-h-8 tw-rounded-full tw-bg-white tw-border tw-border-primary tw-text-primary tw-text-xl tw-transition-transform tw-duration-200"
                        [ngClass]="{ 'tw-rotate-180': openIndex === i }"
                    >
                        <mat-icon class="!tw-font-bold">
                            {{ openIndex === i ? "remove" : "add" }}
                        </mat-icon>
                    </span>
                </button>
                <div
                    *ngIf="openIndex === i"
                    class="tw-px-6 tw-py-4 tw-text-[#000000] tw-text-[14px] lg:tw-text-[18px] tw-font-medium animate-fade-in !tw-bg-[#EDF1FF66] tw-rounded-b-lg tw-lead-[34px]"
                >
                    <p class="tw-text-gray-600 tw-mb-2">
                        {{
                            currentLang === "en"
                                ? faq.subTitleEN
                                : faq.subTitleBM
                        }}
                    </p>
                    <ul
                        *ngIf="
                            (currentLang === 'en' ? faq.answerEN : faq.answerBM)
                                .length > 0
                        "
                        class="tw-list-decimal tw-pl-5 tw-space-y-1"
                    >
                        <li
                            *ngFor="
                                let item of currentLang === 'en'
                                    ? faq.answerEN
                                    : faq.answerBM
                            "
                        >
                            <ng-container
                                *ngIf="
                                    item.includes('imsme.com.my');
                                    else normalText
                                "
                            >
                                {{ item.split("imsme.com.my")[0] }}
                                <a
                                    class="tw-text-primary tw-cursor-pointer"
                                    (click)="navigateToImsme()"
                                    >imsme.com.my</a
                                >
                                {{ item.split("imsme.com.my")[1] }}
                            </ng-container>
                            <ng-template #normalText>
                                {{ item }}
                            </ng-template>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div
        class="tw-hidden lg:tw-flex tw-items-center tw-justify-center tw-w-full lg:tw-w-2/5 tw-sticky tw-top-0 tw-h-[60vh]"
    >
        <img
            src="../../../../../assets/images/About-us/about-us-faq.png"
            alt="about-us-faq"
            class="tw-w-full tw-object-contain tw-m-auto"
        />
    </div>
</div>
